import React from "react";
import Swal from "sweetalert2";
import axios from "axios";

const AddAOwnVehicleModal = ({ isAddOpen, onAddClose, formData, setFormData }) => {
  if (!isAddOpen) return null;


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  console.log("Form Submit Triggered");
  console.log("Form Data:", formData);

  // 🔹 Validation for Vehicle Code
  if (!formData.vCode || formData.vCode.trim() === "") {
    Swal.fire({
      icon: "warning",
      title: "Empty Field",
      text: "Please enter Vehicle Code!",
    });
    return;
  }

  // 🔹 Validation for Vehicle Name
  if (!formData.vName || formData.vName.trim() === "") {
    Swal.fire({
      icon: "warning",
      title: "Empty Field",
      text: "Please enter Vehicle Name!",
    });
    return;
  }

  try {
    Swal.fire({
      title: "Submitting...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const payload = {
      vCode: formData.vCode,
      vName: formData.vName,
    };

    console.log("Payload being sent to server:", payload);

    const response = await axios.post(`https://rfs2.infraconsoft.net.in/api/own_veh_add`, payload);

    console.log("Server response:", response.data);

    if (response.data.success) {
      Swal.fire({
        icon: "success",
        title: "Inserted!",
        text: "Vehicle Name inserted successfully.",
      });
      onAddClose();
      window.location.reload();
    } else {
      console.warn("Insert failed, no 'success' in response:", response.data);
      Swal.fire({
        icon: "error",
        title: "Insert Failed",
        text: response.data.message || "Unknown error.",
      });
    }

  } catch (error) {
        console.error("Error inserting location:", error);
      
        if (error.response && error.response.data && error.response.data.message) {
          Swal.fire({
            icon: "error",
            title: "Insert Failed",
            text: error.response.data.message,  // <-- duplicate message will show here
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Insert failed. Please try again.",
          });
        }
      }
};
  
  return (
    <div className="modal">
      <div className="modal-content" style={{ position: "relative" }}>
      <div style={{ position: "absolute", top: "10px", right: "10px" }}>
        <button className="close-btn" onClick={onAddClose} style={{position: "initial"}}>&times;</button>
        </div>
        <h3>Add New Vehicle Code & Name </h3>
        <form className="vehicle-form" onSubmit={handleSubmit}>
            <div className="form-row">
            <div className="form-group">
                <label>Vehicle Code :</label>
                <input
            type="text"
            name="vCode"
            value={formData.vCode}
            onChange={handleChange}
          />
              </div> 
            </div>

            <div className="form-row">
            <div className="form-group">
                <label>Vehicle Name :</label>
                <input
            type="text"
            name="vName"
            value={formData.vName}
            onChange={handleChange}
          />
              </div> 
            </div>


            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                 Save
              </button>
            </div>
           
            </form>

      </div>
    </div>
  );
};

export default AddAOwnVehicleModal;
